import { Typography } from "antd";

const TrustedPartnersSection = () => {
  return (
    <section className=" trusted-partners-section section-margin-top">
      <div className="container trusted-partners-section-title">
        <Typography.Title level={2} className="m-0">
          Our Trusted Partners
        </Typography.Title>
      </div>
      <div className="brand-logos-wrapper">
        <BrandLogo />
        <BrandLogo />
        <BrandLogo />
        <BrandLogo />
        <BrandLogo />
        <BrandLogo />
        <BrandLogo />
        <BrandLogo />
        <BrandLogo />
      </div>
    </section>
  );
};

export default TrustedPartnersSection;

const BrandLogo = () => <div className="brand-logo"></div>;
